<template>
  <div>
    <v-btn
      class="my-6"
      block
      @click="$store.dispatch('USER/ELIMINATE_LOCAL_STORAGE')"
    >
      Eliminate Local Storage
    </v-btn>
    <v-text-field
      tabindex="-1"
      @change="overrideDate($event)"
      hide-details
      :dark="dark"
      label="Enter a date (YYYY-MM-DD)"
    />
  </div>
</template>

<script>
export default {
  computed: {
    dark() {
      return this.$store.state.USER.settings.dark;
    },
  },
  methods: {
    overrideDate(e) {
      if (this.isProd) return;
      this.$store.commit("USER/DATE_SET", e);
    },
  },
};
</script>

<style></style>
